import { Megaphone } from 'lucide-react';
import type { ModuleSpec } from '../types';

export const campaignsSpec: ModuleSpec = {
  id: 'campaigns',
  icon: Megaphone,
  i18n: {
    namespace: 'modules',
    titleKey: 'campaigns.title',
    descriptionKey: 'campaigns.description',
  },
  nav: {
    path: '/campaigns',
    group: 'run',
    order: 10,
  },
  permission: {
    action: 'read',
    subject: 'campaign',
  },
  meta: {
    status: 'active',
    description: 'Create and manage campaigns',
  },
};
